export const fixRoot = () => {
  document.documentElement.style.overflow = 'hidden';
};

export const unfixRoot = () => {
  document.documentElement.style.overflow = '';
};

export default { fixRoot, unfixRoot };
